/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./image-preview-popover.vue?vue&type=template&id=1f8019ec&scoped=true&"
import script from "./image-preview-popover.vue?vue&type=script&lang=js&"
export * from "./image-preview-popover.vue?vue&type=script&lang=js&"
import style0 from "./image-preview-popover.vue?vue&type=style&index=0&id=1f8019ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8019ec",
  null
  
)

export default component.exports